import { useState, useEffect } from 'react'
import { getPublishedNews } from '../services/newsService'
import type { News } from '../types'

export function useNews(limitCount = 10) {
  const [news, setNews] = useState<News[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function fetchNews() {
      try {
        setLoading(true)
        const data = await getPublishedNews(limitCount)
        setNews(data)
      } catch (err) {
        setError(err as Error)
        console.error('Failed to fetch news:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchNews()
  }, [limitCount])

  return { news, loading, error }
}

